import UserTransactionTable from './UserActivityTransactionTable';

export default UserTransactionTable;